module.exports = __webpack_public_path__ + "img/hwdl15.fb6725d9.jpg";